var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneNumberVerification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4864",
    "data-name": "Rectangle 4864",
    width: 60,
    height: 60,
    transform: "translate(554 5446)",
    fill: "#e6e8f0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phone_number_verification",
    "data-name": "phone number verification",
    transform: "translate(-554 -5446)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11530",
    "data-name": "Group 11530",
    transform: "translate(570.552 5454.276)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4610",
    "data-name": "Rectangle 4610",
    width: 26.897,
    height: 44.483,
    rx: 4,
    transform: "translate(0 0)",
    fill: "#4972f4",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4611",
    "data-name": "Rectangle 4611",
    d: "M0,0H10.345a0,0,0,0,1,0,0V2.138a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V0A0,0,0,0,1,0,0Z",
    transform: "translate(8.276 0)",
    fill: "#102d6f",
    stroke: "#fff",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11531",
    "data-name": "Group 11531",
    transform: "translate(575.431 5474.054)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1748",
    "data-name": "Ellipse 1748",
    transform: "translate(0)",
    fill: "#ffb063",
    stroke: "#f9f9fc",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.8,
    cy: 1.8,
    rx: 1.8,
    ry: 1.8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.8,
    cy: 1.8,
    rx: 2.45,
    ry: 2.45,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1749",
    "data-name": "Ellipse 1749",
    transform: "translate(6.774)",
    fill: "#ffb063",
    stroke: "#f9f9fc",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.8,
    cy: 1.8,
    rx: 1.8,
    ry: 1.8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.8,
    cy: 1.8,
    rx: 2.45,
    ry: 2.45,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1750",
    "data-name": "Ellipse 1750",
    transform: "translate(13.548)",
    fill: "#ffb063",
    stroke: "#f9f9fc",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.8,
    cy: 1.8,
    rx: 1.8,
    ry: 1.8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.8,
    cy: 1.8,
    rx: 2.45,
    ry: 2.45,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11532",
    "data-name": "Group 11532",
    transform: "translate(575.431 5481.558)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1753",
    "data-name": "Ellipse 1753",
    transform: "translate(0)",
    fill: "#ffb063",
    stroke: "#f9f9fc",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.8,
    cy: 1.8,
    rx: 1.8,
    ry: 1.8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.8,
    cy: 1.8,
    rx: 2.45,
    ry: 2.45,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1752",
    "data-name": "Ellipse 1752",
    transform: "translate(6.774)",
    fill: "#ffb063",
    stroke: "#f9f9fc",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.8,
    cy: 1.8,
    rx: 1.8,
    ry: 1.8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.8,
    cy: 1.8,
    rx: 2.45,
    ry: 2.45,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1751",
    "data-name": "Ellipse 1751",
    transform: "translate(13.548)",
    fill: "#ffb063",
    stroke: "#f9f9fc",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.8,
    cy: 1.8,
    rx: 1.8,
    ry: 1.8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.8,
    cy: 1.8,
    rx: 2.45,
    ry: 2.45,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11533",
    "data-name": "Group 11533",
    transform: "translate(575.431 5489.063)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1756",
    "data-name": "Ellipse 1756",
    transform: "translate(0)",
    fill: "#ffb063",
    stroke: "#f9f9fc",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.8,
    cy: 1.8,
    rx: 1.8,
    ry: 1.8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.8,
    cy: 1.8,
    rx: 2.45,
    ry: 2.45,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1755",
    "data-name": "Ellipse 1755",
    transform: "translate(6.774)",
    fill: "#ffb063",
    stroke: "#f9f9fc",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.8,
    cy: 1.8,
    rx: 1.8,
    ry: 1.8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.8,
    cy: 1.8,
    rx: 2.45,
    ry: 2.45,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1754",
    "data-name": "Ellipse 1754",
    transform: "translate(13.548)",
    fill: "#ffb063",
    stroke: "#f9f9fc",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.8,
    cy: 1.8,
    rx: 1.8,
    ry: 1.8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.8,
    cy: 1.8,
    rx: 2.45,
    ry: 2.45,
    fill: "none"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneNumberVerification);
export default __webpack_public_path__ + "static/media/phone_number_verification.0d9eda2cad8c9efe4861576b0155e1fe.svg";
export { ForwardRef as ReactComponent };